<template>
  <div class="modal-level2-bottom" v-if="$route.path != '/myrequest'">
    <!-- <div
      class="mr20"
      v-show="!$store.state.editStore.isLegaldocEdit"
      @click="setLegalDocEdit(true)"
    >
      EDIT
    </div>
    <div
      class="mr20"
      v-show="$store.state.editStore.isLegaldocEdit"
      @click="setLegalDocCancel(false)"
    >
      CANCEL
    </div> -->
    <div class="mr20" @click="setEdit()">
      <!-- {{ $get($store, 'state.editStore.isEditInfo') ? 'CANCEL' : 'EDIT' }} -->
      {{
        editingStatus == 1 || editingStatus == true
          ? `CANCEL ( ${editingUser} )`
          : `EDIT`
      }}
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    editingStatus() {
      return this.$get(
        this.$store,
        'state.editingStore.legaldoc_level_1.is_open',
        0
      )
    },
    editingUser() {
      return this.$get(
        this.$store,
        'state.editingStore.legaldoc_level_1.open_by',
        ''
      )
    },
    editingId() {
      return this.$get(
        this.$store,
        'state.editingStore.legaldoc_level_1.id',
        ''
      )
    },
  },
  methods: {
    setLegalDocEdit(value) {
      this.$store.commit('editStore/SET_DATA', {
        name: 'isLegaldocEdit',
        value,
      })
    },
    setLegalDocCancel(value) {
      this.$store.commit('editStore/SET_DATA', {
        name: 'isLegaldocEdit',
        value,
      })
    },
    setEdit() {
      if (this.editingStatus == 1 || this.editingStatus == true) {
        this.$store.dispatch('editingStore/deleteEditingStatus', {
          id: this.editingId,
          is_open: 0,
          open_by: this.$store.state.currentUser,
          user_id: this.$store.state.userid,
          vendor_id: this.$store.state.level1.vendorId,
          name: 'legaldoc_level_1',
        })
      } else {
        this.$store.dispatch('editingStore/addEditingStatus', {
          is_open: 1,
          desc: 'legaldoc_level_1',
          open_by: this.$store.state.currentUser,
          user_id: this.$store.state.userid,
          vendor_id: this.$store.state.level1.vendorId,
          name: 'legaldoc_level_1',
        })
      }
      // this.$store.commit('SET_NOTIF', 'Maaf, Fitur sedang dalam pengembangan.')
    },
  },
}
</script>
